import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Checkbox, Form, Input, Select, Typography } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import ReactDOM from 'react-dom';
import PhoneInput from '../components/PhoneInput';
import { DefaultValueProvider,FixedValueProvider } from './index';
import COUNTRY from 'country-json/src/country-by-abbreviation.json';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

const { Text } = Typography;

export default (formPlugin, namespace) => {

    return {
        Renderer: (props) => {
            let containerRef = useRef(null)
            const [listField, setlistField] = useState(undefined)
            const { data } = props

            const namespaceId = props.pluginConfig.namespace?.split("/").filter(i => i)[0]
            const nodeExtraData = formPlugin.getExtraData(props.nodeId, listField?.name)
            const [copyIdentity, setCopyIdentity] = useState(nodeExtraData?.copyIdentity || false)

            useEffect(() => {
                setlistField(props.pluginConfig.getListField(containerRef.current))
            }, [])

            useEffect(() => {
                if (nodeExtraData?.copyIdentity !== undefined && nodeExtraData?.copyIdentity !== copyIdentity) {
                    setCopyIdentity(nodeExtraData?.copyIdentity)
                }
            }, [nodeExtraData?.copyIdentity])

            if (props.remove) {
                formPlugin.onAddFormPlugin(props, props.nodeId, props.pluginConfig.id)
            }

            if ((props.isPreviewMode || props.readOnly) && !props.data.fieldKey) {
                return null
            }

            var reducedWidth = data.reduced ? "48%" : "100%"
            const listFieldProps = listField ? { ...listField, key: undefined } : null
            const finalName = "[CONTACT]_" + data.fieldKey
            const extraName = listField ? [listField.name, finalName].flat() : finalName
            const withRelations = formPlugin.formData?.withRelations || false

            return (
                <div ref={(ref) => containerRef.current = ref}>

                    {data.allowCopyIdentity && (
                        <Form.Item shouldUpdate={(prev, cur) => JSON.stringify(prev?.identity) !== JSON.stringify(cur?.identity)}>
                            {(_form) => (
                                <Checkbox
                                    onChange={(e) => {
                                        setCopyIdentity(e.target.checked)
                                        formPlugin.registerExtraData(props.nodeId, { copyIdentity: e.target.checked }, listField?.name)
                                    }}
                                    checked={copyIdentity}
                                >
                                    <Trans>Copier mes informations</Trans>
                                </Checkbox>
                            )}
                        </Form.Item>
                    )}

                    <Form.Item noStyle shouldUpdate={true}>
                        {(_form) => {

                            let _defaultValue=undefined
                            var fixedGenre = false
                            if (data.fixedGenre === "Homme" || data.fixedGenre === "Femme") {
                                fixedGenre = true
                                _defaultValue=data.fixedGenre === "Homme"
                            }

                            return (
                                <Form.Item
                                    {...listFieldProps}
                                    label={t`Civilité` + " :"}
                                    name={listField ? [listField.name, finalName, "homme"].flat() : [finalName, "homme"]}
                                    rules={[{
                                        required: data.required,
                                        message: t`Ce champ est obligatoire`
                                    }]}
                                >
                                    <FixedValueProvider defaultValue={_defaultValue}>
                                        <Select disabled={fixedGenre || copyIdentity} size="large" placeholder={t`Civilité`}>
                                            <Select.Option value={true}><Trans>Monsieur</Trans></Select.Option>
                                            <Select.Option value={false}><Trans>Madame</Trans></Select.Option>
                                        </Select>
                                    </FixedValueProvider>
                                </Form.Item>
                            )
                        }}
                    </Form.Item>

                    {withRelations && !copyIdentity && (
                        <Form.Item noStyle shouldUpdate={true}>
                            {(_form) => {
                                let prefix = finalName
                                if (listField) prefix = [listField.name, finalName]
                                const namespaces = props.pluginConfig?.namespace?.split("/").filter(i => i) || []
                                let identity = _form.getFieldValue("identity")
                                let homme = _form.getFieldValue([namespaces, prefix, "homme"].flat())

                                let label = t`Il/elle est`
                                if (homme === true) label = t`Il est`
                                if (homme === false) label = t`Elle est`

                                let options = formPlugin.RELATIONS_OPTIONS


                                let _defaultValue=undefined
                                var fixedRelation = false
                                if (options.some(i=>i.value===data.fixedRelation)) {
                                    fixedRelation = true
                                    _defaultValue=data.fixedRelation
                                }

                                return (
                                    <Form.Item
                                        {...listFieldProps}
                                        label={label + " :"}
                                        name={listField ? [listField.name, finalName, "_relation"].flat() : [finalName, "_relation"]}
                                        rules={[{
                                            required: data.required,
                                            message: t`Ce champ est obligatoire`
                                        }]}
                                    >
                                        <FixedValueProvider defaultValue={_defaultValue}>
                                            <Select disabled={fixedRelation} size="large" placeholder={label}>
                                                {options.map(i => {
                                                    let _label = i.labelH + " / " + i.labelF
                                                    if (homme === true) _label = i.labelH
                                                    if (homme === false) _label = i.labelF

                                                    let _name = identity?.prenom && identity?.nom ? `${identity.prenom} ${identity.nom}` : null

                                                    return (
                                                        <Select.Option value={i.value}>
                                                            {_label + " "}
                                                            {!!_name && (
                                                                <Text>
                                                                    <Trans>de</Trans> <Text strong> {_name}</Text>
                                                                </Text>
                                                            )}
                                                        </Select.Option>
                                                    )
                                                })}
                                                <Select.Option value="OTHER"><Trans>Autre</Trans></Select.Option>
                                            </Select>
                                        </FixedValueProvider>
                                    </Form.Item>
                                )
                            }}
                        </Form.Item>
                    )}

                    <div style={{ display: data.reduced ? "flex" : "block", justifyContent: "space-between" }}>
                        <Form.Item
                            {...listFieldProps}
                            label={(data.labelPrenom || t`Prénom`) + " :"}
                            name={listField ? [listField.name, finalName, "prenom"].flat() : [finalName, "prenom"]}
                            rules={[{
                                required: data.required,
                                message: t`Ce champ est obligatoire`
                            }, {
                                pattern: /^[A-zÀ-ú\s]*$/,
                                message: t`Le champ doit contenir uniquement des lettres`
                            }]}
                            style={{ width: reducedWidth }}
                        >
                            <Input disabled={copyIdentity} type="text" placeholder={data.labelPrenom || t`Prénom`} />
                        </Form.Item>

                        <Form.Item
                            {...listFieldProps}
                            label={(data.labelNom || t`Nom`) + " :"}
                            name={listField ? [listField.name, finalName, "nom"].flat() : [finalName, "nom"]}
                            rules={[{
                                required: data.required,
                                message: t`Ce champ est obligatoire`
                            }, {
                                pattern: /^[A-zÀ-ú\s]*$/,
                                message: t`Le champ doit contenir uniquement des lettres`
                            }]}
                            style={{ width: reducedWidth }}
                        >
                            <Input disabled={copyIdentity} type="text" placeholder={data.labelNom || t`Nom`} />
                        </Form.Item>
                    </div>

                    <div style={{
                        display: (data.reduced && props.device === "DESKTOP") ? "flex" : "block",
                        justifyContent: "space-between"
                    }}>
                        {data.ignoreEmail !== true && (
                            <Form.Item
                                {...listFieldProps}
                                label={(data.labelEmail || t`Email`) + " :"}
                                name={listField ? [listField.name, finalName, "email"].flat() : [finalName, "email"]}
                                rules={[{
                                    required: data.required,
                                    message: t`Ce champ est obligatoire`
                                }, {
                                    pattern: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                                    message: t`L'adresse email n'est pas valide`
                                }, {
                                    validator: (rules, _value) => {
                                        const identity = formPlugin.formRef.getFieldValue("identity")
                                        const identityEmail = identity?.email?.toLowerCase()
                                        return new Promise((resolve, reject) => {
                                            if (!identityEmail || !_value || copyIdentity) return resolve(true)
                                            if (_value.toLowerCase() !== identityEmail) return resolve(true)
                                            return reject(t`L'adresse email ne doit pas être la même que la vôtre`)
                                        })
                                    }
                                }]}
                                style={{ width: (data.reduced && props.device === "DESKTOP") ? reducedWidth : "100%" }}
                            >
                                <Input disabled={copyIdentity} type="email" placeholder={data.labelEmail || t`Email`} />
                            </Form.Item>
                        )}

                        <Form.Item
                            {...listFieldProps}
                            label={(data.labelTel || t`Téléphone`) + " :"}
                            name={listField ? [listField.name, finalName, "tel"].flat() : [finalName, "tel"]}
                            rules={[{
                                required: data.required,
                                message: t`Ce champ est obligatoire`
                            }, {
                                validator: (_, _value) => (!isNaN(_value) || !_value) ? Promise.resolve(true) : Promise.reject(t`Le numéro de téléphone est invalide`)
                            }, {
                                validator: (rules, _value) => {
                                    const identity = formPlugin.formRef.getFieldValue("identity")
                                    const identityTel = identity?.tel?.toLowerCase()
                                    return new Promise((resolve, reject) => {
                                        if (!identityTel || !_value || copyIdentity) return resolve(true)
                                        if (_value.toLowerCase() !== identityTel) return resolve(true)
                                        return reject(t`Le numéro de téléphone ne doit pas être le même que le vôtre`)
                                    })
                                }
                            }]}
                            style={{ width: (data.reduced && props.device === "DESKTOP") ? reducedWidth : "100%" }}
                        >
                            <PhoneInput disabled={copyIdentity} defaultLang={props.lang} placeholder={data.labelTel || t`Téléphone`} />
                        </Form.Item>
                    </div>

                    {data.full && (
                        <Fragment>
                            <Form.Item
                                {...listFieldProps}
                                label={(data.labelAdresse || t`Adresse`) + " :"}
                                name={listField ? [listField.name, finalName, "adresse"].flat() : [finalName, "adresse"]}
                                rules={[{
                                    required: data.required,
                                    message: t`Ce champ est obligatoire`
                                }]}
                            >
                                <Input type="text" placeholder={data.labelAdresse || t`Adresse`} />
                            </Form.Item>

                            <div style={{ display: data.reduced ? "flex" : "block", justifyContent: "space-between" }}>
                                <Form.Item
                                    {...listFieldProps}
                                    label={(data.labelPostal || t`Code Postal`) + " :"}
                                    name={listField ? [listField.name, finalName, "postal"].flat() : [finalName, "postal"]}
                                    rules={[{
                                        required: data.required,
                                        message: t`Ce champ est obligatoire`
                                    }, {
                                        pattern: /^[0-9]*$/,
                                        message: t`Le champ doit contenir uniquement des chiffres`
                                    }]}
                                    style={{ width: reducedWidth }}
                                >
                                    <Input type="text" placeholder={data.labelPostal || t`Code Postal`} />
                                </Form.Item>

                                <Form.Item
                                    {...listFieldProps}
                                    label={(data.labelVille || t`Ville`) + " :"}
                                    name={listField ? [listField.name, finalName, "ville"].flat() : [finalName, "ville"]}
                                    rules={[{
                                        required: data.required,
                                        message: t`Ce champ est obligatoire`
                                    }, {
                                        pattern: /^[A-z0-9À-ú\s]*$/,
                                        message: t`Le champ doit contenir uniquement des lettres`
                                    }]}
                                    style={{ width: reducedWidth }}
                                >
                                    <Input type="text" placeholder={data.labelVille || t`Ville`} />
                                </Form.Item>
                            </div>

                            <Form.Item
                                {...listFieldProps}
                                label={t`Pays` + " :"}
                                name={listField ? [listField.name, finalName, "pays"].flat() : [finalName, "pays"]}
                                rules={[{
                                    required: data.required,
                                    message: t`Ce champ est obligatoire`
                                }]}
                            >
                                <DefaultValueProvider defaultValue={COUNTRY.find(i => i.abbreviation === formPlugin.getCountry())?.country}>
                                    <select className="form-control">
                                        <option unselectable disabled><Trans>Pays</Trans></option>
                                        {COUNTRY.map(i => (
                                            <option value={i.country}>{i.country}</option>
                                        ))}
                                    </select>
                                </DefaultValueProvider>
                            </Form.Item>

                            {data.showNote && (
                                <Form.Item
                                    {...listFieldProps}
                                    label={(data.labelNote || t`Complément d'adresse`) + " :"}
                                    name={listField ? [listField.name, finalName, "note_adresse"].flat() : [finalName, "note_adresse"]}
                                >
                                    <Input placeholder={data.labelNote || t`Complément d'adresse`} />
                                </Form.Item>
                            )}
                        </Fragment>
                    )}

                    {listField !== undefined && (
                        <div className="form-field" data-field={JSON.stringify({ key: extraName, name: extraName })}>
                            {props.children}
                        </div>
                    )}
                </div>
            )
        },
        namespace: namespace,
        id: 'form-contact' + namespace,
        title: t`Champ Contact`,
        description: t`Élément de formulaire utilisable.`,
        icon: <UserOutlined />,
        iconColor: "#F39C12",
        version: 1,
        getListField: (containerRef) => {
            const listField = ReactDOM.findDOMNode(containerRef)?.closest(".form-field")?.dataset.field
            if (listField) return JSON.parse(listField)
            return null
        },
        cellPlugins: (plugins, data) => {
            const initialPlugins = formPlugin.getPluginsMem(namespace).filter(i =>
                !i.id.includes("form-contact") &&
                !i.id.includes("form-child") &&
                !i.id.includes("form-hazkara") &&
                !i.id.includes("form-identity") &&
                !i.id.includes("form-product") &&
                !i.id.includes("form-step-container") &&
                !i.id.includes("form-submit-button") &&
                !i.id.includes("form-free-amount") &&
                !i.id.includes("form-paiement-method") &&
                !i.id.includes("form-calendar")
            )
            return [...initialPlugins, ...formPlugin.getContactFormPlugins(namespace)]
        },
        controls: {
            type: 'autoform',
            schema: {
                properties: {
                    required: {
                        type: 'boolean',
                        uniforms: { label: t`Obligatoire` }
                    },
                    full: {
                        type: 'boolean',
                        uniforms: { label: t`Contact Complet` }
                    },
                    reduced: {
                        type: 'boolean',
                        uniforms: { label: t`Formulaire Réduit` }
                    },
                    allowCopyIdentity: {
                        type: 'boolean',
                        uniforms: { label: t`Permettre la copie des informations identitaires` }
                    },
                    fieldKey: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Identifiant`,
                            placeholder: t`Identifiant du Champ`
                        }
                    },
                    labelNom: {
                        type: 'string',
                        uniforms: {
                            label: t`Étiquette Nom`,
                            placeholder: t`Étiquette Nom`
                        }
                    },
                    labelPrenom: {
                        type: 'string',
                        uniforms: {
                            label: t`Étiquette Prénom`,
                            placeholder: t`Étiquette Prénom`
                        }
                    },
                    labelEmail: {
                        type: 'string',
                        uniforms: {
                            label: t`Étiquette Email`,
                            placeholder: t`Étiquette Email`
                        }
                    },
                    ignoreEmail: {
                        type: 'boolean',
                        uniforms: { label: t`Masquer l'email` }
                    },
                    labelTel: {
                        type: 'string',
                        uniforms: {
                            label: t`Étiquette Téléphone`,
                            placeholder: t`Étiquette Téléphone`
                        }
                    },
                    labelAdresse: {
                        type: 'string',
                        uniforms: {
                            label: t`Étiquette Adresse`,
                            placeholder: t`Étiquette Adresse`,
                            showIf: (data) => data.full
                        }
                    },
                    labelPostal: {
                        type: 'string',
                        uniforms: {
                            label: t`Étiquette Postal`,
                            placeholder: t`Étiquette Postal`,
                            showIf: (data) => data.full
                        }
                    },
                    labelVille: {
                        type: 'string',
                        uniforms: {
                            label: t`Étiquette Ville`,
                            placeholder: t`Étiquette Ville`,
                            showIf: (data) => data.full
                        }
                    },
                    showNote: {
                        type: 'boolean',
                        uniforms: { label: t`Afficher le Complément d'adresse` }
                    },
                    fixedGenre: {
                        type: 'string',
                        uniforms: {
                            label: t`Fixer le genre`,
                            allowedValues: ["Homme", "Femme"],
                            transform: (value) => {
                                if(value==="Homme"){
                                    return t`Homme`
                                }else{
                                    return t`Femme`
                                }
                            },
                        }
                    },
                    fixedRelation: {
                        type: 'string',
                        uniforms: {
                            label: t`Fixer la relation`,
                            allowedValues: formPlugin.RELATIONS_OPTIONS.map(i=>i.value),
                            transform: (value) => {
                                let opt=formPlugin.RELATIONS_OPTIONS.find(i=>i.value === value)
                                return opt.labelH+" / "+opt.labelF
                            },
                        }
                    },
                }
            }
        }
    }
}
